import React from 'react';

const ArrowIconWhite: React.FC = () => {
  return (
    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.8773 2L18.3753 1.92307L18.2987 0.429961L16.8053 0.501729L16.8773 2ZM4.60361 13.4923L3.60449 14.6111L5.84214 16.6093L6.84125 15.4905L4.60361 13.4923ZM10.0811 0.824883L8.58287 0.896888L8.72688 3.89343L10.2251 3.82142L10.0811 0.824883ZM15.7292 8.8917L15.8062 10.3897L18.8022 10.2359L18.7253 8.73785L15.7292 8.8917ZM16.8773 2L15.7585 1.00088L4.60361 13.4923L5.72243 14.4914L6.84125 15.4905L17.9961 2.99912L16.8773 2ZM16.8773 2L16.8053 0.501729L10.0811 0.824883L10.1531 2.32315L10.2251 3.82142L16.9493 3.49827L16.8773 2ZM16.8773 2L15.3793 2.07693L15.7292 8.8917L17.2273 8.81478L18.7253 8.73785L18.3753 1.92307L16.8773 2ZM4.43414 16.0581L3.32179 15.0518L0.660356 17.9937L1.77271 19L2.88505 20.0063L5.54649 17.0645L4.43414 16.0581Z" fill="white"/>
    </svg>
    
  );
};

export default ArrowIconWhite;
